import { createSelector } from '@ngrx/store';

import * as fromFollows from '@core/reducers/follow.reducer';
import * as fromRoot from '@core/reducers/root.reducer';
import { Follow } from '@app/models/follow';

export const hasFollows = createSelector(
  fromFollows.getFollows,
  (follows: Follow[]) => !!follows.length
);

export const getBusy = createSelector(
  fromFollows.getFollowsLoaded,
  fromFollows.getFollowsLoading,
  fromRoot.getExportingFile,
  (loaded, loading, exporting) => {
    const busy = (!loaded && loading) || exporting;
    return busy;
  }
);
export const getFollowsWithBUs = createSelector(
  fromRoot.getFollowsPopulated,
  follows => {
    return follows
      ? follows.map(follow => {
          const businessUnits =
            follow &&
            follow.Businesses &&
            follow.Businesses.reduce((arr, business) => {
              if (!arr.map(a => a.code).includes(business.code)) {
                arr = [
                  ...arr,
                  { name: business.name, code: business.code }
                ].sort((a, b) => a.name.localeCompare(b.name));
              }
              return arr;
            }, []);
          return { ...follow, businessUnits };
        })
      : [];
  }
);
